import { render, staticRenderFns } from "./RemindInfo.vue?vue&type=template&id=2105f334&scoped=true&"
import script from "./RemindInfo.vue?vue&type=script&lang=js&"
export * from "./RemindInfo.vue?vue&type=script&lang=js&"
import style0 from "./RemindInfo.vue?vue&type=style&index=0&id=2105f334&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2105f334",
  null
  
)

export default component.exports